// extracted by mini-css-extract-plugin
export default {"checkReleases":"_Gk5hfhp1hDVycN5tM5n","linkBtn":"nP_WIsLeOoFMfAkkPP7p"};